/* eslint-disable @typescript-eslint/ban-types */
import React, { useMemo } from 'react';
import { Row, ColumnInstance } from 'react-table';

import { getEstimatedLossLabel } from '@trqk/utils';

interface EstimatedLossFooterProps<D extends object> {
    column: ColumnInstance<NumberRange>;
    flatRows: Row<D>[];
}

/**
 * Sums and displays the total of all cell values for the Estimated Loss column.
 * @param props - {@link EstimatedLossFooterProps}
 */
export function EstimatedLossFooter<D extends object>({
    column,
    flatRows,
}: EstimatedLossFooterProps<D>): JSX.Element {
    const summedRange = useMemo(
        () =>
            flatRows.reduce(
                (acc: NumberRange, row: Row<D>): NumberRange => {
                    if (row.depth === 0 && row.canExpand) {
                        acc.max += row?.values?.[column.id]?.max ?? 0;
                        acc.min += row?.values?.[column.id]?.min ?? 0;
                    }

                    return acc;
                },
                { max: 0, min: 0 },
            ),
        [flatRows],
    );

    return <>{getEstimatedLossLabel(summedRange)}</>;
}
